import { useEffect } from 'react';

export const SITE_URL = 'https://noorjewerly.ir';
const BRAND = 'جواهری نور';
const DEFAULT_TITLE = 'جواهری نور | خرید آنلاین طلا و جواهر';
const DEFAULT_DESC =
  'جواهری نور - خرید آنلاین طلا و جواهر با بهترین قیمت. گردنبند، دستبند، انگشتر، گوشواره و سرویس طلا با ضمانت اصالت.';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

// آدرس نسبی (/media/...) را به آدرس کامل تبدیل می‌کند
export const absUrl = (u) => {
  if (!u) return '';
  return u.startsWith('http') ? u : `${SITE_URL}${u.startsWith('/') ? '' : '/'}${u}`;
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

/**
 * تنظیم عنوان، توضیحات، canonical، Open Graph و داده‌ی ساخت‌یافته برای هر صفحه.
 *   title       عنوان صفحه (برند خودکار اضافه می‌شود). خالی = عنوان پیش‌فرض سایت
 *   description توضیح متا (۱۲۰ تا ۱۶۰ حرف)
 *   path        مسیر canonical، مثل '/product/12' یا '/products?category=ring'
 *   image       تصویر شبکه‌های اجتماعی (نسبی یا کامل)
 *   robots      مثلاً 'noindex, nofollow' برای صفحات خصوصی
 *   jsonLd      آبجکت schema.org
 */
export default function useSeo({ title, description, path, image, robots, type = 'website', jsonLd } = {}) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : '';

  useEffect(() => {
    const fullTitle = title ? `${title} | ${BRAND}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = SITE_URL + (path !== undefined ? path : window.location.pathname);
    const img = image ? absUrl(image) : DEFAULT_IMAGE;

    document.title = fullTitle;
    setMeta('name', 'description', desc);
    setMeta('name', 'robots', robots || 'index, follow');
    setCanonical(url);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', img);
    setMeta('property', 'og:type', type);
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', desc);

    let script = null;
    if (ld) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo', 'page');
      script.text = ld;
      document.head.appendChild(script);
    }

    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
      document.title = DEFAULT_TITLE;
      setMeta('name', 'description', DEFAULT_DESC);
      setMeta('name', 'robots', 'index, follow');
      setMeta('property', 'og:title', DEFAULT_TITLE);
      setMeta('property', 'og:description', DEFAULT_DESC);
      setMeta('property', 'og:image', DEFAULT_IMAGE);
      setMeta('property', 'og:type', 'website');
      const c = document.head.querySelector('link[rel="canonical"]');
      if (c && c.parentNode) c.parentNode.removeChild(c);
    };
  }, [title, description, path, image, robots, type, ld]);
}